import type { AnalyticsRecord } from '@/utils/services/analytics/AnalyticsDataService';

import type { StatsConfig } from '@/components/composite/MediaViewer/components/MediaViewerStats/types';

import ChartWrapper from '@/components/composite/MediaViewer/charts/ChartWrapper';
import AnalyticsGrid, { GRID_STYLES } from '@/components/layouts/wrappers/AnalyticsGrid';

type ChartGridItemProps = {
    config: StatsConfig;
    isLoading: boolean;
    isLoadingAnalytics: boolean;
    analytics: AnalyticsRecord | null;
    userNumbersFormat: string;
};

export const ChartGridItem = ({
    config,
    isLoading,
    isLoadingAnalytics,
    analytics,
    userNumbersFormat
}: ChartGridItemProps) => {
    const analyticsForConfig = analytics?.[config.id];

    const chartData =
        analytics && typeof analyticsForConfig === 'object' && analyticsForConfig !== null
            ? { ...config, ...(analyticsForConfig as Record<string, unknown>) }
            : { ...config };
    const ChartElement = config.element;

    return (
        <AnalyticsGrid.Item
            size={config.size}
            gridStyle={GRID_STYLES.MEDIA_VIEWER}
            className="min-h-[130px]">
            <ChartWrapper
                className=""
                isLoading={isLoading || isLoadingAnalytics}
                userNumbersFormat={{ number: userNumbersFormat }}
                hasShadow={false}
                data={chartData}>
                {ChartElement && <ChartElement />}
            </ChartWrapper>
        </AnalyticsGrid.Item>
    );
};
